import { API, postJSON } from "../../api.js";
import { $, esc, fmtMoney } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";
import { toast } from "../../ui/modals.js";
import { renderBriefingInto } from "./briefing.js";

function openDealPostmortemModal(basePath, dealId) {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  backdrop.innerHTML = `<div class="modal modal-page" style="max-width:640px;"><div class="modal-page-body" style="padding:28px;">Loading…</div></div>`;
  document.body.appendChild(backdrop);

  fetch(`${API}${basePath}/${dealId}/postmortem`).then((r) => r.json()).then((pm) => {
    const priorityColor = { High: "var(--oxblood)", Medium: "var(--brass)", Low: "var(--text-low)" };
    const name = pm.deal.company_name || pm.deal.country_name;
    const outcomeLabel = !pm.resolved ? "Still Open" : {
      rejected: "Rejected", signed_full: "Signed — Full Terms", signed_reduced: "Signed — Reduced Scope",
      finalized_full: "Finalized — Full Terms", finalized_reduced: "Finalized — Reduced Terms",
    }[pm.outcome] || pm.outcome;
    const timelineHtml = pm.timeline.map((e) => `
      <div style="display:flex; gap:10px; padding:6px 0; border-bottom:1px solid var(--line-soft); font-size:11.5px;">
        <span class="mono" style="color:var(--text-low); min-width:48px;">M${e.month}</span>
        <span style="color:var(--text-mid);">${esc(e.type.replace(/_/g, " "))}${e.payload.tactic ? ` (${esc(e.payload.tactic)})` : ""}${e.payload.backfired ? " — backfired" : ""}</span>
      </div>
    `).join("");
    backdrop.querySelector(".modal-page-body").innerHTML = `
      <h3 style="margin-bottom:4px;">Why did this happen? — ${esc(name)}</h3>
      <div style="font-size:11px; color:var(--brass); font-weight:600; margin-bottom:18px;">${esc(outcomeLabel)}</div>
      <div class="projected-profile" style="grid-template-columns:repeat(3,1fr);">
        <div><div class="projected-stat-label">Initial Probability</div><div class="projected-stat-value">${Math.round((pm.summary.initial_probability || 0) * 100)}%</div></div>
        <div><div class="projected-stat-label">Final Probability</div><div class="projected-stat-value">${Math.round((pm.summary.final_probability || pm.summary.current_probability || 0) * 100)}%</div></div>
        <div><div class="projected-stat-label">Renegotiations</div><div class="projected-stat-value">${pm.summary.negotiation_count || 0}</div></div>
      </div>
      ${pm.items.map((item) => `
        <div class="alert-card" style="align-items:flex-start; border-left:3px solid ${priorityColor[item.priority] || "var(--line)"}; margin-bottom:10px;">
          <div>
            <div class="alert-category">${esc(item.priority)} Priority</div>
            <div class="alert-message">${esc(item.observation)}</div>
            <div style="color:var(--brass); font-size:12px; margin-top:5px;">→ ${esc(item.recommendation)}</div>
          </div>
        </div>
      `).join("")}
      ${pm.timeline.length ? `<div style="margin-top:16px;"><div style="font-size:10px; color:var(--text-low); text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px;">Timeline</div>${timelineHtml}</div>` : ""}
      <div class="modal-actions" style="margin-top:20px;"><button id="modal-cancel">Close</button></div>
    `;
    backdrop.querySelector("#modal-cancel").addEventListener("click", () => backdrop.remove());
  });
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) backdrop.remove(); });
}

// ---------------------------------------------------------------- Deals & Partners


export { openDealPostmortemModal };
